import { Address } from './address';
import { AreaLocation } from './areaLocation';

export class ConnectionAddress extends Address {
  constructor(application_id: number) {
    super(application_id);
  }

  connectionobject_id: number;
  district: string;
  residential_unit_no?: string;
  floor?: string;
  area_locations: AreaLocation[];
}
